import { VALUE_DIRECTION, datasetTypeSymbols, datasetTypes } from '@/constants';
import { formatUnit } from '@/utils/string-utils';
import { HeaderSm } from './header-sm';
import * as kpi from './kpi-ribbon-sm-styles';
import { TrendDisplay } from './trend-display';

/**
 * Small version of KPI ribbon. This component is meant to be used inside a small card
 *
 * @param {string} props.label
 * @param {string} props.value
 * @param {string} props.trend
 * @param {string} props.delta
 */
export function KpiRibbonSm(props) {
  const {
    label,
    latestKpi,
    labelFontSize,
    valueFontSize,
    expand,
    enableTrend,
    latestKpiDescription,
    symbol,
    children,
  } = props;
  const { trend, value, amountChange } = latestKpi;
  const rise = trend === 'rise';

  return (
    <HeaderSm labelFontSize={labelFontSize} label={label}>
      <kpi.Col>
        <kpi.ValueRow expand={expand}>
          <kpi.ValueWrapper>
            <TrendDisplay
              enableTrend={enableTrend}
              value={formatUnit(value, symbol, false)}
              isActive={true} // TODO: Ask Bing if we still need this
              trend={trend}
              symbol={
                symbol ===
                datasetTypeSymbols[datasetTypes.CURRENT_STR_PROPERTIES]
                  ? symbol
                  : ''
              }
              valueFontSize={valueFontSize}
            />
          </kpi.ValueWrapper>
          <kpi.DeltaChildrenWrapper expand={expand}>
            <kpi.Delta rise={Boolean(rise)}>
              {formatUnit(
                amountChange,
                symbol,
                false,
                rise ? VALUE_DIRECTION.INCREASE : VALUE_DIRECTION.DECREASE
              )}
            </kpi.Delta>
            {children}
          </kpi.DeltaChildrenWrapper>
        </kpi.ValueRow>
        {latestKpiDescription && (
          <kpi.Description>{latestKpiDescription}</kpi.Description>
        )}
      </kpi.Col>
    </HeaderSm>
  );
}
